<template>
  <thead>
    <tr>
      <th v-if="headInfo.fstColumn" class="funcHead" :style="headInfo.style"></th>
      <template v-if="Array.isArray(headInfo.dataList)">
        <th v-for="(item, index) in headInfo.dataList" :key="index">
          <div class="title">{{$t(`table.head.${item.key}`)}}</div>
          <div v-if="item.sort" class="sort">
            <button class="sort up" :class="{'active': (item.sortKey || item.key) === orderColumn && orderType === 'ASC'}" @click="$emit('sort', item.sortKey || item.key, 'ASC')"> > </button>
            <button class="sort down" :class="{'active': (item.sortKey || item.key) === orderColumn && orderType === 'DESC'}" @click="$emit('sort', item.sortKey || item.key, 'DESC')"> > </button>
          </div>
        </th>
      </template>
      <template v-if="!Array.isArray(headInfo.dataList)">
        <th v-for="(option,key) in headInfo.dataList" :style="option?{width:option+'%'}:''" :key="key">{{$t(`table.head.${key}`)}}</th>
      </template>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'TableHead',
  props: [
    'headInfo',
    'orderColumn',
    'orderType'
  ],
  watch: {
    orderColumn () {
      console.log(this.orderColumn)
    }
  },
  created() {
    console.log(this.orderType, this.orderColumn)
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
button{
  height:40px;
  border:1px solid black;
}
th {
  height: 40px;
  /* background: var(--main); */
  background: #353535;
  color: #fff;
  vertical-align: middle;
  /* font-size:0.750em; */
  font-size:14px;
  position: relative;
}
div.title {

}
div.sort {
  position: absolute;
  top:0;
  right: 0;
  width: 24px;
}
button.sort {
  border: inherit;
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: #6f6565;
  z-index: 99999;
  width: 18px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0);
}
.sort.up {
  /*rotate: 270deg;*/
  transform: rotate(270deg);
}

.sort.down {
  /*rotate: 90deg;*/
  transform: rotate(90deg);
}

.sort.active {
  color: #fff;
}

.funcHead{
  width:0;
}
</style>
